module.exports = "/images/vendor/tui-image-editor/dist/svg/icon-c.svg?6f440c0d2fa852de523edfd5383ad682";